export default __webpack_public_path__ + "static/media/Rodage.7f4acd78.png";